import siteService from '@/api/site'
import { SITE } from '../types'

export default {
  namespaced: true,
  state: {
    sites: []
  },
  mutations: {
    [SITE.SET_SITES] (state, sites) {
      state.sites = sites
    }
  },
  actions: {
    async getSiteList ({commit, dispatch}) {
      try {
        let response = await siteService.getSites()
        commit(SITE.SET_SITES, response.data)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async addSite ({dispatch}, site) {
      try {
        await siteService.addSite(site)
        dispatch('getSiteList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async editSite ({dispatch}, site) {
      try {
        await siteService.editSite(site)
        dispatch('getSiteList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async inheritGlobalSettings({dispatch}, site) {
      try {
        await siteService.inheritSettings(site)
        dispatch('getSiteList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    }
  }
}